<template>
  <div :data-time="time">
    <template v-if='statusGeral !== ""'>
      <RF-Dialog
        :cpntStatus='statusGeral'
        :cpntStatusImprimir="true"
        :cpntOnFecharDialog='cliExportarIniciar'>
        <template slot='titulo'>
          <div style="text-align: center;">
            Erro ao realizar o download do arquivo.
            <br/><br/>
            Por favor entre em contato com suporte via telefone
            <br/><br/>
            (41) 3076-7488.
          </div>
        </template>
      </RF-Dialog>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div class="cliente-exportar noselect" style="text-align: center;">
        <template v-if="page === 'senha'">
          <h3>Este arquivo de exportação requer senha para baixá-lo:</h3>
          
          <div class="div-form">
            <input id="ipt-pass" type="password" class="ipt" @keyup.enter='cliExportarBuscarLink' placeholder="Digite a Senha" v-model="senha">
          </div>
          <div class="div-form">
            <button id="bt-download" class="btn btn-success bt" @click="cliExportarBuscarLink">Baixar</button>
          </div>
        </template>
        <template v-else-if="page === 'fim'">
          <h3>O download deve começar em instantes...</h3>
          <h4>
            <br>
            Nosso suporte:<br><br>
            Fone 41 3076-7488<br><br>
            E-mail <a href="mailto:atendimento@subase.com.br"><font class="texto_tam18" style="color:#333436">atendimento@subase.com.br</font></a><br><br>
            De Segunda a Sexta das 09:00 às 12:00 e das 13:30 às 18:00
          </h4>
        </template>

        <template v-if="[ 'fim', 'senha' ].indexOf(page) !== -1">
          <div class="exportar-logo">
            <a href="http://www.rotinafacil.com.br" target="_blank" title="Rotina Fácil - O Software Amigo do Empresário">
              <img src="/img/rotina_facil.png">
            </a>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<style>
  .cliente-exportar {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0px;
    left: 0px;
    padding-top: 170px;
    background-color: #fff;
    background-image: url('/img/bg-exp.jpg');
    background-repeat: no-repeat;
    background-position-x: center
  }
    .cliente-exportar > h3 {
      font-size: 24px;
    }
    .cliente-exportar > h4 {
      font-size: 18px;
    }
      .cliente-exportar > h4 > a {
        color: #333436;
      }
    .exportar-logo {
      width: 100%;
      text-align: center;
      position: absolute;
      top: calc(170px + 250px);
    }
  .div-form {
    padding-top: 80px;
    margin: 0px 5px;
    display: inline-block;
    vertical-align: middle;
  }
  select, textarea, input[type="text"], input[type="password"], .uneditable-input {
    background-color: #fff;
    border: 1px solid #ccc;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    -webkit-transition: border linear .2s, box-shadow linear .2s;
    -moz-transition: border linear .2s, box-shadow linear .2s;
    -o-transition: border linear .2s, box-shadow linear .2s;
    transition: border linear .2s, box-shadow linear .2s;
  }
  select, textarea, input[type="text"], input[type="password"], .uneditable-input {
    padding: 4px 6px;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
  }
  .ipt {
    font-size: 22px;
    font-family: Corbel;
    width: 300px;
  }
</style>

<script>
  export default {
    components: {
      'RF-Progress': () => import('@/components/rf-geral/progress/RF-Progress.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        page: '',
        titulo: '',
        senha: ''
      }
    },
    mounted: function () {
      this.cliExportarIniciar()
    },
    methods: {
      cliExportarIniciar: function () {
        // SETA QUE O DOWNLOAD INICIOU
        this.cliExportarSetarPagina('ini')

        // LINK SEM SENHA
        // http://subase-sup:8090/df/exportar/MWRnRnNtamFiVVZQMzIraXdKY2dGWTc3TnhFajlqbWt3ejh0dXNDci9LOD0%3D

        // LINK COM SENHA
        // http://subase-sup:8090/df/exportar/MWRnRnNtamFiVVZQMzIraXdKY2dGVHFjRWh5eDc2WThtcUUwMDBkeHY1UT0%3D

        if ([ '', null, undefined ].indexOf(this.$route.params) === -1 && [ '', null, undefined ].indexOf(this.$route.params.link) === -1) {
          try {
            // PEGA O LINK RECEBIDO
            var linkGet = window.atob(decodeURI(this.$route.params.link))

            // INICIA A CHAVA PARA DESCRIPTOGRAFAR O LINK
            var chave = window.btoa('SUBASE_' + process.env.VUE_APP_MGT_CHA_PAR);

            // COLOCA ZERO A ESQUERDA DA CHAVE, SE ELA FOR MENOR QUE 32 CARACTERES
            chave = (chave.length <= 32 ? ('00000000000000000000000000000000' + chave).slice(-32) : chave).substring(0, 32)

            // DESCRIPTOGRAFA O VALOR RECEBIDO E CONVERTE O JSON EM OBJETO
            linkGet = JSON.parse(this.$store.state.FUN_CRIPTOGRAFIA('dec', linkGet, chave))

            switch (linkGet.p) {
              case true:
                // SETA QUE O DOWNLOAD INICIOU
                this.cliExportarSetarPagina('senha')
                break

              case false:
                this.cliExportarBuscarLink()
                break
            
              default:
                this.cliExportarSetarPagina('erro', { loc: 'WEB', cod: 500, err: 'Erro ao identificar informações do link.' })
                break
            }
          } catch (err) {
            this.cliExportarSetarPagina('erro', { loc: 'WEB', cod: 500, err: 'Erro ao descriptografar link.' })
          }
        } else {
          this.cliExportarSetarPagina('erro', { loc: 'WEB', cod: 500, err: 'Erro ao identificar link.' })
        }
      },
      cliExportarBuscarLink: function () {
        var self = this

        if ([ '', null, undefined ].indexOf(self.$route.params) === -1 && [ '', null, undefined ].indexOf(self.$route.params.link) === -1) {
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA API
          var formData = { linkGet: decodeURI(self.$route.params.link), password: self.senha, apenasLink: '1' }

          // MONTA O FORMULARIO PARA ENVIO A API
          self.$store.state.comunicaAPI('/subase/df/exp/link', 'PUT', formData, function (apiSuccess) {
            // MONTA O BOTÃO PARA DOWNLOAD
            var element = document.createElement('a')
            element.setAttribute('href', apiSuccess.data.link)
            element.style.display = 'none';
            document.body.appendChild(element)
            element.click()
            document.body.removeChild(element)

            // SETA QUE O DOWNLOAD INICIOU
            self.cliExportarSetarPagina('fim')            
          }, function (apiError) {
            // SETA QUE DEU ERRO NA GERAÇÃO DO ARQUIVO
            self.cliExportarSetarPagina('erro', apiError)
          }, function (apiValid, apiStatus) {
            switch (self.page) {
              case 'senha':
                self.$store.state.FUN_API_RET_VALIDA(self, '', apiValid, apiStatus, {}, true, function () {
                  // LIMPA A SENHA DIGITADA
                  self.senha = ''

                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  self.time = new Date().getTime()
                })
                break
            
              default:
                self.cliExportarSetarPagina('erro', { loc: 'API', cod: apiStatus, err: apiValid.geralWeb })
                break
            }
          })
        } else {
          self.cliExportarSetarPagina('erro', { loc: 'WEB', cod: 500, err: 'Erro ao realizar o download do arquivo CÓD. (1).<br/><br/>Por favor entre em contato com suporte via telefone<br/><br/>(41) 3076-7488.' })
        }
      },
      cliExportarSetarPagina: function (page, erro = null) {
        switch (page) {
          case 'erro':
            // SETA A PAGINA
            this.page = 'erro'

            // SETA A MENSAGEM DE ERRO
            this.statusGeral = erro

            // SETA QUE ESTA CARREGANDO
            this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }])
            break

          case 'ini':
            // SETA A PAGINA
            this.page = page

            // SETA QUE ESTA CARREGANDO
            this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: true }])
            break

          case 'senha':
          case 'fim':
            // SETA A PAGINA
            this.page = page

            // SETA QUE ESTA CARREGANDO
            this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }])
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    }
  }
</script>
